export function formattedValueNumber(value, isNumber) {
    if (isNumber && value === '') return '0';
    return  (/^[0-9]+$/.test(value) ? String(Number(value)) : value);
}